import apiBasic from "../apiBasic";
import { instance } from "../handelApi";

//-----------------------------------------取得table資料----------------------------------------
export const getLotdata = (_params) => {
  return instance.get(`${apiBasic.conn}://${apiBasic.url}/api/getLotdata`, {
    params: _params,
  });
};